import React from 'react';
import PropTypes from 'prop-types';
import { FACT_FILE_INDEX } from '@constants/routes';
import { trackClickEvent } from '@utils/analytics';
import Image from '@components/Image';
import AnchorLink from '@components/AnchorLink';
import s from './FactFileThumbs.module.scss';

const propTypes = {
  thumbs: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string,
      displayTitle: PropTypes.string,
      category: PropTypes.string,
      imageUrl: PropTypes.string,
      images: PropTypes.array,
    }),
  ),
};

const FactFileThumbs = ({ thumbs = [] }) => {
  const trackFactFileClick = (factFile, index) => {
    const { externalId, category, displayTitle } = factFile;
    trackClickEvent(
      {
        destination_url: `${FACT_FILE_INDEX}/${category}/${externalId}`,
        label: `Fact File - ${displayTitle}`,
        location: 'Fact File List',
        vertical_index: 4,
        horizontal_index: index,
        content_name: displayTitle,
      },
      factFile,
    );
  };

  return (
    <>
      {thumbs.map((factFile, index) => {
        const firstImageUrl = factFile?.imageUrl || factFile?.images?.[0]?.image?.file?.url;

        return (
          <AnchorLink
            key={factFile.externalId}
            className={[s.filterItem, s[`category-${factFile.category}`]].join(' ')}
            href={`${FACT_FILE_INDEX}/${factFile.category}/${factFile.externalId}`}
            onClick={() => {
              trackFactFileClick(factFile, index);
            }}
          >
            <div
              data-testid="FactFileThumbImageContainer"
              className={[s.imageContainer, !firstImageUrl ? s.showDefaultImage : ''].join(' ')}
            >
              {firstImageUrl && (
                <Image
                  imageSet={[{ src: `${firstImageUrl}?w=200&fm=webp` }]}
                  alt={factFile.displayTitle}
                  cover
                  lazy
                />
              )}
            </div>
            <div className={s.title}>{factFile.displayTitle}</div>
            <div className={s.categoryBookmark}>
              <div className={s.categoryBookmarkInner} />
            </div>
          </AnchorLink>
        );
      })}
    </>
  );
};

FactFileThumbs.propTypes = propTypes;
export default FactFileThumbs;
